import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Assess",
    body:
      "We audit your business, find the gaps, and calculate exactly how much revenue you're leaving behind.",
  },
  {
    n: "02",
    title: "Build",
    body:
      "We design and deploy AI systems tailored to your specific workflows, audience, and goals.",
  },
  {
    n: "03",
    title: "Automate",
    body:
      "Your systems run 24/7. You get monthly reports, ongoing optimization, and a team that scales with you.",
  },
];

export default function Process() {
  return (
    <section
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <span
              className="text-xs uppercase tracking-[0.22em] text-[#00d4ff]/90"
              data-testid="process-eyebrow"
            >
              Our Process
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="font-display mt-3 text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05]"
              data-testid="process-headline"
            >
              Three Steps to <br />
              <span className="text-zinc-400">Transformation</span>
            </motion.h2>
            <p className="mt-5 text-zinc-400 max-w-md">
              A simple, transparent process designed to deliver measurable
              outcomes — not vague promises.
            </p>
          </div>

          <div className="lg:col-span-8 relative">
            {/* Connecting line - desktop */}
            <div
              aria-hidden
              className="hidden md:block absolute left-0 right-0 top-6 mx-12 h-px bg-gradient-to-r from-transparent via-[#00d4ff]/40 to-transparent"
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ delay: i * 0.1, duration: 0.55 }}
                  data-testid={`process-step-${i}`}
                  className="relative flex flex-col items-center md:items-start text-center md:text-left"
                >
                  <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#00d4ff]/50 bg-[#0a0a0f] font-display text-[#00d4ff] text-lg font-semibold shadow-[0_0_20px_rgba(0,212,255,0.3)]">
                    {i + 1}
                  </span>
                  <h3 className="font-display mt-5 text-xl md:text-2xl font-semibold text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-zinc-400 max-w-xs">
                    {s.body}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
